var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-next-button",
    d: "M874.091,605.266a1,1,0,0,1,1.413.057l3.231,3.5a1,1,0,0,1,0,1.356l-3.231,3.5a1,1,0,1,1-1.47-1.356l1.682-1.822H866a1,1,0,0,1,0-2h9.716l-1.682-1.822A1,1,0,0,1,874.091,605.266Z",
    transform: "translate(-865 -605.001)",
    fill: "#fcfcfd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrowNext.3861853bc2e570e60e6ab43ba8d0f443.svg";
export { ForwardRef as ReactComponent };